import { trackEvent } from './segment';

export const trackPPOVisionStarted = ({
  brands,
  colorIntensity,
  colorPreference,
  consultation,
  furnitureBudget,
  inspiration,
  keyPieces,
  keyPiecesAdditionalInfo,
  notes,
  studioId,
  spaceUsage,
  specialConsiderations,
  totalBudget,
  flexibility,
  doNotExceedAmount,
  exceedsAggregate,
  doYouWantTv,
  whatSizeTv,
  whereToPlaceTv,
  additionalMedia
}) => {
  trackEvent({
    event: 'ppo_project_vision_started',
    properties: {
      brands,
      color_intensity: colorIntensity,
      color_preference: colorPreference,
      consultation,
      furniture_budget: furnitureBudget,
      inspiration,
      key_pieces: keyPieces,
      key_pieces_additional_info: keyPiecesAdditionalInfo,
      notes,
      studio_id: studioId,
      space_usage: spaceUsage,
      special_considerations: specialConsiderations,
      total_budget: totalBudget,
      flexibility,
      do_not_exceed_amount: doNotExceedAmount,
      exceeds_aggregate: exceedsAggregate,
      TV_preferences: {
        doYouWantTv,
        whatSizeTv,
        whereToPlaceTv,
        additionalMedia
      }
    }
  });
};

export const trackPPOInspirationLinkErrors = ({
  links
}) => {
  trackEvent({
    event: 'ppo_inspiration_links_error',
    properties: {
      links
    }
  });
};

export const trackPPOExistingFurnitureStarted = ({
  additionalProduct,
  customPieces,
  customPiecesIncorporate,
  customPiecesSummary,
  numberOfCustomPieces,
  studioId
}) => {
  trackEvent({
    event: 'ppo_existing_furniture_started',
    properties: {
      additional_product: additionalProduct,
      custom_pieces: customPieces,
      custom_pieces_incorporate: customPiecesIncorporate,
      custom_pieces_summary: customPiecesSummary,
      number_of_custom_pieces: numberOfCustomPieces,
      studio_id: studioId
    }
  });
};

export const trackPPOProjectSubmitted = ({
  studioId,
  userEmail
}) => {
  trackEvent({
    event: 'ppo_project_submitted',
    properties: {
      studio_id: studioId,
      user_email: userEmail
    }
  });
};

export const trackCustomPropPaymentComplete = ({
  orderTotal,
  studioId
}) => {
  trackEvent({
    event: 'custom_prop_payment_complete',
    properties: {
      order_total: orderTotal,
      studio_id: studioId
    }
  });
};

export const trackPPODashboardViewed = ({
  packageType = '',
  stepsCompleted = [],
  studioId = null
}) => {
  trackEvent({
    event: 'ppo_dashboard_view',
    properties: {
      studio_id: studioId,
      package_type: packageType,
      steps_completed: stepsCompleted
    }
  });
};

export const trackPPOPhotoAndMeasurementStarted = ({
  studioId = null
}) => {
  trackEvent({
    event: 'ppo_p&m_started',
    properties: {
      studio_id: studioId
    }
  });
};

export const trackPPOExperimentalActivated = ({
  userId = null,
  studioId = null,
  experimentalFeatureFlag = null
}) => {
  trackEvent({
    event: 'ppo_p&m_experimental_activated',
    properties: {
      user_id: userId,
      studio_id: studioId,
      experimental_featureFlag: experimentalFeatureFlag
    }
  });
};

export const trackPPOMeasurementsUpdated = ({
  studioId = null,
  measurementEntered = ''
}) => {
  trackEvent({
    event: 'ppo_p&m_measurements',
    properties: {
      studio_id: studioId,
      measurements_entered: measurementEntered
    }
  });
};

export const trackPPOMeasurementsWarnings = ({
  studioId = null,
  measurementEntered = '',
  warningMessageShown = ''
}) => {
  trackEvent({
    event: 'ppo_p&m_measurements_warnings',
    properties: {
      studio_id: studioId,
      measurements_entered: measurementEntered,
      warning_message_shown: warningMessageShown
    }
  });
};

export const trackPPOPhotosInstructionsSelected = ({
  spaceId,
  userId
}) => {
  trackEvent({
    event: 'how_to_take_photos_video_click',
    properties: {
      space_id: spaceId,
      user_id: userId
    }
  });
};

export const trackPPOMeasurementsSelected = ({
  spaceId,
  userId
}) => {
  trackEvent({
    event: 'how_to_measure_room_video_click',
    properties: {
      space_id: spaceId,
      user_id: userId
    }
  });
};

export const trackPPOTrickySpacesSelected = ({
  spaceId,
  userId
}) => {
  trackEvent({
    event: 'how_to_take_photos_tricky_space_video_click',
    properties: {
      space_id: spaceId,
      user_id: userId
    }
  });
};

export const trackPPOFloorPlanUploaded = ({
  studioId = null
}) => {
  trackEvent({
    event: 'ppo_p&m_upload_floorplan',
    properties: {
      studio_id: studioId
    }
  });
};

export const trackPPOPhotosUploaded = ({
  studioId = null,
  numberOfPhotos = 0 // Total Number of uploaded photos after this addition/removal
}) => {
  trackEvent({
    event: 'ppo_p&m_upload_photos',
    properties: {
      studio_id: studioId,
      number_of_photos: numberOfPhotos
    }
  });
};

export const trackPPOPhotosWarnings = ({
  studioId = null,
  warningMessageShown = ''
}) => {
  trackEvent({
    event: 'ppo_p&m_photos_warnings',
    properties: {
      studio_id: studioId,
      warning_message_shown: warningMessageShown
    }
  });
};

export const trackPPOPhotosSubmitted = ({
  studioId = null,
  numberOfPhotos = 0
}) => {
  trackEvent({
    event: 'ppo_p&m_photos_submitted',
    properties: {
      studio_id: studioId,
      number_of_photos: numberOfPhotos
    }
  });
};

export const trackPPOWhoLivesHereSubmitted = ({
  studioId,
  aboutYou,
  whoLivesHere,
  additionalInfo
}) => {
  trackEvent({
    event: 'ppo_who_lives_here_started',
    properties: {
      studio_id: studioId,
      about_you: aboutYou,
      who_lives_here: JSON.stringify(whoLivesHere),
      additional_info: additionalInfo
    }
  });
};
